import React, { useEffect, useState } from "react";
import "./My_Wallet.css";
import { Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import Add_Money from "./add_money/Add_Money";
import OrderCard from "../../common_components/order_card/OrderCard";
import Success_Modal from "../../common_components/common_modal/success_modal/Success_Modal";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import { getAllWalletHistory } from "../../../features/wallet/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDateTime } from "../../../utils/common";
import WalletHistory from "../../common_components/order_card/WalletHistory";

const My_Wallet = () => {
  const dispatch = useDispatch();
  const walletHistory = useSelector((state) => state.wallet.allWalletHistory);

  useEffect(() => {
    dispatch(getAllWalletHistory());
  }, [dispatch]);

  return (
    <section className="My_Wallet">
      <div className="container">
        <Common_Back_Header backNavigation="/my-profile" />

        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="tabs_holder">
            <Nav variant="pills" className="">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <span className="tab_text">Add Money</span>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="second">
                  <span className="tab_text">Wallet Transactions</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <div className="">
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Add_Money walletHistory={walletHistory} />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  {walletHistory?.data?.map((val) => (
                    <WalletHistory
                      //   navigate="/order-details"
                      title={val?.description}
                      footer_text_color="#D60000"
                      img="/assets/images/profile/myaccount/img1.png"
                      orderId="Order ID #675843"
                      transaction_id={val?.transaction_id}
                      kwd={Number(val?.amount || 0).toFixed(2)}

                      date={formatDateTime(val?.createdAt)}
                    />
                  ))}

                  {/* <OrderCard navigate="/order-details" title="ScanMart Grocery" footer_text_color="#D60000"
                                        img="/assets/images/profile/myaccount/img1.png" orderId="Order ID #675843" items="2 Items" kwd="Rs.: 200"

                                        date="27th Oct. | 03:28 pm" /> */}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </section>
  );
};

export default My_Wallet;
